import { getDataCompany } from '@/services/financial';
import { CACHE_TTL } from '@/services/constants';
import { useImpersonation } from '@/contexts/ImpersonationContext';
import { useQuery } from '@tanstack/react-query';

export default function useCompanyData({ enabled = true } = {}) {
  const { impersonatedUserId } = useImpersonation();
  const isImpersonating = !!impersonatedUserId;

  // Nao remover a query no onError. removeQueries() com observers vivos derruba o cache,
  // o React Query reinscreve na hora e (com refetchOnMount) refaz o request, que erra de
  // novo: loop infinito sem backoff. Erro aqui para em isError e fica no erro.
  const {
    data: companyData,
    isFetching: isLoadingCompany,
    isError: hasCompanyDataError,
    error: companyDataError,
    refetch: refetchCompanyData,
  } = useQuery({
    queryKey: ['financial.company'],
    queryFn: () => getDataCompany(),
    enabled: enabled && !isImpersonating,
    staleTime: CACHE_TTL,
    retry: false,
  });

  return {
    companyData,
    isLoadingCompany,
    hasCompanyDataError,
    companyDataError,
    refetchCompanyData,
  };
}
